import { apiFetch } from "./client";

export interface RuntimeFeatures {
  assessment: boolean;
  web_interview: boolean;
  respondent_chat: boolean;
}

export interface RuntimeInfo {
  env: "prod" | "staging" | "dev" | string;
  features: RuntimeFeatures;
  /** Absolute URL of the respondent own-twin chat SPA on this deployment
   *  (null when not configured) — the completion screen links to it. */
  respondent_chat_url?: string | null;
}

export const runtimeApi = {
  info: () => apiFetch<RuntimeInfo>("/runtime/info"),
};
